// All persistent storage for auth goes through here.
//
// The task pane runs as a cross-site iframe inside outlook.office.com, so the
// browser treats its localStorage as third-party. Edge's tracking prevention
// (and Chrome with third-party cookies blocked) either throws a SecurityError
// on access or hands out ephemeral storage that is discarded when the pane
// closes. An unguarded localStorage call there takes down session restore
// entirely, so every access is wrapped and falls back to an in-memory map that
// lasts for the lifetime of the task pane.

const memory = new Map<string, string>();

let persistentStorageWorks = true;

/** False once a localStorage access has thrown — surfaced in sign-in diagnostics. */
export const isPersistentStorageAvailable = (): boolean => persistentStorageWorks;

export function storageGet(key: string): string | null {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      return value;
    }
  } catch {
    persistentStorageWorks = false;
  }
  return memory.get(key) ?? null;
}

export function storageSet(key: string, value: string): void {
  memory.set(key, value);
  try {
    localStorage.setItem(key, value);
  } catch {
    persistentStorageWorks = false;
  }
}

export function storageRemove(key: string): void {
  memory.delete(key);
  try {
    localStorage.removeItem(key);
  } catch {
    persistentStorageWorks = false;
  }
}
